import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import DestinationLags from "./_langs";
import {GenericTableButton} from "../../../components/buttons/buttonsActions"
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import SelectGeneric from "../../../components/select/selectGeneric";
import DestinationActivity from "../destinationActivity/destinationActivity";

// labels
import {PH_CODE, PH_IMAGE, PH_ORDER} from "../../../components/i18n/placeHolders"
import {FORM, LB_CODE, INTERNATIONAL, LB_ORDER, REQUIRED, LB_AFI} from "../../../components/i18n/i18n"
import {FL_IMAGE} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {destinationService} from "../../../jwt/_services/xailing/destinationService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {afiProvider} from "../../../providers/hotel/afiProvider";

const DestinationForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []
    const [showModal, setShowModal] = useState(true)
    const [afi, setAfi] = useState(domainObject?.afi?.id || null)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            image: domainObject?.image,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs,
                afi: afi ? { id: afi } : null
            }
        };

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if(afi !== undefined && afi !== null)
            dataRequest.item.afi = { id: afi }

        if (!editMode)
            genericIndexedActions.save(path, destinationService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, destinationService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return  <>

            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                            onClick={() => handleSubmit(onSubmit)()}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col Col md="6">
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>{LB_CODE}</Label>
                                            <Input
                                                type="text"
                                                name="code"
                                                placeholder={PH_CODE}
                                                innerRef={register}
                                            />
                                            {errors.code && <div className="invalid-feedback"
                                                                 style={{'display': 'block'}}>{errors?.code?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>{FL_IMAGE}</Label>
                                            <Input
                                                type="text"
                                                name="image"
                                                placeholder={PH_IMAGE}
                                                innerRef={register}
                                            />
                                            {errors.image && <div className="invalid-feedback"
                                                                  style={{'display': 'block'}}>{errors?.image?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md="8">
                                        <FormGroup>
                                            <SelectGeneric
                                                title={LB_AFI}
                                                initialValue={afi}
                                                setExternalValue={setAfi}
                                                provider={afiProvider}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>{LB_ORDER}</Label>
                                            <Input
                                                type="number"
                                                name="showOrder"
                                                placeholder={PH_ORDER}
                                                innerRef={register}
                                            />
                                            {errors.showOrder && <div className="invalid-feedback"
                                                                      style={{'display': 'block'}}>{errors?.showOrder?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="2">
                                        <FormGroup>
                                            <Label>{'Activo'}</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                value={status}
                                                onChange={() => setStatus(!status)}
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <div className={'form-container'}>
                                    <div className={''}>
                                        <h2>{INTERNATIONAL}</h2>
                                    </div>
                                    <div className={''}>
                                        <DestinationLags langs={langs} setLangs={setlangs}
                                                                  translatableLangs={domainObject?.translatedLangs || []}/>
                                    </div>
                                </div>
                            </Form>
                        </Col>
                        {
                            editMode && <Col Col md="6">
                                <DestinationActivity path={path} app={app}/>
                            </Col>
                        }

                    </Row>
                </CardBody>
            </Card>


        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>
}
export default DestinationForm